/**
 * 校验某个uri是否有权限
  GET /rbac/user/hasPermission
  接口ID：178414219
  接口地址：https://app.apifox.com/link/project/3817514/apis/api-178414219
 */

import { get } from "../utils/fetch";

/**
 * AuthResult
 */

export var apiRbacUserHasPermission = function apiRbacUserHasPermission(query) {
  return get({
    url: '/rbac/user/hasPermission',
    query: query
  });
};